//
import Service from "@/services/Service"

/**
 * @description
 * Auth services and functionality
 * 
 */
export default class AuthService extends Service {

    /**
     * @description
     * Parse for get Module token
     * 
     * @param {String} defaultToken - the default module token
     * @return {String}
     */
    fetchModuleToken ( defaultToken = "" ) {
        return String( new URL( window.location.href ).get( "module_token" ) || defaultToken )
    }

    /**
     * @description
     * Call request for get Login token
     * 
     * @param {Object} params
     * @return {Promise}
     */
    fetchLoginToken ( params ) {
        return this.$http.get( "get_login_token", {
            params 
        })
    }
    
    /**
     * @description
     * Call request for get Logout
     * 
     * @param {Object} params
     * @return {Promise}
     */
    fetchLogout ( params ) {
        return this.$http.get( "logout", {
            params 
        })
    }

    /**
     * @description
     * The endpoint auth service api
     * 
     * @return {String}
     */
    resource () {
        return "auth"
    }
}